// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useMemo} from 'react';
import cn from 'classnames';
import {os2readable} from '../../shared/util.js';
import {PLATFORMS, PLATFORM_ALIASES} from '../../shared/constants.js';
import {Select as Select_comp} from '../select.js';
import {Text} from '../text';
import {OS} from './os.js';
import * as cns from './select.module.less';

const get_items = core_only=>{
    const items = Object.keys(PLATFORMS)
        .filter(k=>k!='roku' && (core_only ? true : !PLATFORMS[k].hidden))
        .map(key=>({value: key, label: os2readable(key)}));
    if (!core_only)
    {
        const aliases = Object.keys(PLATFORM_ALIASES).map(key=>({
            value: key,
            alias_for: PLATFORM_ALIASES[key].for,
            label: PLATFORM_ALIASES[key].label,
        }));
        items.push(...aliases);
    }
    items.sort((a, b)=>a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1);
    return items;
};

const OS_ITEMS = get_items();
const OS_ITEMS_CORE = get_items(true);

export {OS_ITEMS, OS_ITEMS_CORE};
export const ANY_OS_ITEM = {value: 'any', label: 'Any OS'};

const render = (val, primary, className)=>{
    const classes = cn(cns.item, className);
    if (val.value==ANY_OS_ITEM.value)
        return <Text.xxs className={classes}>{val.label}</Text.xxs>;
    return <OS key={val.value} className={classes} os={val.value}
      size="xxs" bold={false} icon_color={primary ? 'primary': 'main'}/>;
};

const render_option = opt=>render(opt, false, cns.option);
const render_value = opt=>render(opt, true);

export function Select({
    className,
    value,
    on_change,
    multi,
    exclude,
    size,
    auto_focus,
    core_only,
    has_any,
})
{
    const list = useMemo(()=>{
        const basis = core_only ? OS_ITEMS_CORE : OS_ITEMS;
        const items = basis.filter(item=>!exclude?.includes(item.value));
        if (has_any)
            items.unshift(ANY_OS_ITEM);
        return items;
    }, [core_only, exclude, has_any]);
    return <Select_comp className={className} value={value}
      on_change={on_change} options={list} multi={multi} size={size}
      placeholder="Select an OS" auto_focus={auto_focus}
      render_value={render_value} render_option={render_option}/>;
}
